import React, {Component} from 'react'
import {
    Row,
    Col,
    Input,
    Badge,
    Popover,
    PopoverHeader,
    PopoverBody,
    ListGroup,
    ListGroupItem,
    Button,
    Label
} from 'reactstrap'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import Moment from "moment/moment"
import {extendMoment} from 'moment-range';
import _ from 'lodash'
import {firstBy} from 'thenby'
import {toast} from 'react-toastify'

const moment = extendMoment(Moment);

const QUERY = gql`query user($user_id: Int!, $week_commencing: String){
	user(user_id: $user_id){
    user_id
    first_name
    last_name
    project_activities(week_commencing: $week_commencing){
      user_project_activity_id
      project_activity_type{
        project_activity_type_id
        description
      }
      project{
        project_id_prefix
        project_id
        name
      }
      timesheets{
        id
        __typename
        user_project_activity_id
        timesheet_date
        user_id
        minutes_worked
        hours_worked
      }
      user_schedule{
        id
        start_date
        end_date
      }
      project_activity_budget{
        id
        description
        parent{
          stage
          address{
            full_address
        	}
        }
        address{
          full_address
        }
        comments(user_id: $user_id){
          id
          project_activity_budget_id
          note
          created_at
          user_id
          public
          user{
            first_name
            last_name
          }
        }
      }
    }
    unbillable_timesheets(week_commencing: $week_commencing){
      id
      __typename
      unbillable_type_id
      timesheet_date
      user_id
      minutes_worked
      hours_worked
      
    }
  }
}`

const MUTATION = gql`mutation upsert_user_timesheet($user_id: Int!, $timesheet: TimesheetInput!){
  upsert_user_timesheet(user_id: $user_id, timesheet: $timesheet){
    id
    __typename
    user_project_activity_id
    timesheet_date
    user_id
    minutes_worked
    hours_worked
  }
}`

const COMMENTS_MUTATION = gql`mutation go($data: ProjectActivityBudgetNoteInput!){
  upsert_project_activity_budget_notes(data: $data){
      id
      project_activity_budget_id
      note
      created_at
      user_id
      public
      user{
        first_name
        last_name
      }
  }
}`

export default class Timesheets extends Component {


    state = {
        popoversOpen: {},
        note: '',
        public: true,
    }

    componentDidMount() {
        const {subscribeToComments} = this.props
        if (subscribeToComments) subscribeToComments()
    }

    getExistingTimesheetValue = (date, timesheets) => {
        const existingTimesheet = timesheets.find(timesheet => moment(timesheet.timesheet_date).format('YYYY-MM-DD') == date)
        return (existingTimesheet) ? ((existingTimesheet.hours_worked) ? existingTimesheet.hours_worked : '') : ''
    }

    timesheetChanged = (value, date, user_project_activity_id, upsert) => {
        const timesheet_date = moment(date).format('YYYY-MM-DD')
        const timesheet = {timesheet_date, hours_worked: (value) ? value : null, user_project_activity_id}
        upsert({
            variables: {user_id: this.props.user_id, timesheet}, optimisticResponse: {
                __typename: "Mutation",
                upsert_user_timesheet: {
                    id: `${user_project_activity_id}-${timesheet_date}`,
                    __typename: "Timesheet",
                    user_project_activity_id,
                    timesheet_date,
                    user_id: this.props.user_id,
                    minutes_worked: value * 60,
                    hours_worked: value
                }
            }
        })
            .then(res => {
            }, e => toast.error(e.message, {autoClose: false}))

    }

    toggle = (id) => {

        console.log(id)
        let popoversOpen = {...this.state.popoversOpen}
        popoversOpen[id] = (this.state.popoversOpen[id]) ? false : true

        this.setState({public: true})

        console.log(popoversOpen)

        this.setState({popoversOpen})
    }

    renderComments = (comments) => {
        return comments
            .sort((c1, c2) => c2.id - c1.id)
            .map(comment => {
                return (
                    <ListGroupItem key={comment.id}>
                        {comment.note}
                        <br/>
                        <small><strong>{comment.user.first_name} {comment.user.last_name}</strong></small>
                        {' '}
                        <small>{moment(comment.created_at).format('Do MMM YY')}</small>
                    </ListGroupItem>
                )
            })
    }

    render() {

        const {activities, days, week_commencing} = this.props


        return (JSON.parse(JSON.stringify(activities))
                .sort(firstBy((pa1, pa2) => (pa1.project.project_id_prefix === 'RCD') ? 1 : -1)
                    .thenBy((pa1, pa2) => pa1.project.project_id - pa2.project.project_id))
                .map(activity => (
                    <Row style={{
                        borderBottomColor: '#f0f3f5',
                        borderBottomStyle: 'solid',
                        borderBottomWidth: '1px',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                    }} key={activity.user_project_activity_id}>
                        <Col className="col-2">
                            {`${activity.project.project_id} `}
                            <span>
                                <Badge id={'Popover-' + activity.user_project_activity_id} color="primary" pill
                                       onClick={() => this.toggle(activity.user_project_activity_id)}>{activity.project_activity_budget.comments.length}</Badge>
                                <Popover
                                    placement="right"
                                    isOpen={this.state.popoversOpen[activity.user_project_activity_id] || false}
                                    target={'Popover-' + activity.user_project_activity_id}
                                    toggle={() => this.toggle(activity.user_project_activity_id)}
                                >
                                    <PopoverHeader>Comments</PopoverHeader>
                                    <PopoverBody>
                                        <div style={{
                                            marginBottom: '65px',
                                            maxHeight: '25vh',
                                            minHeight: '100px',
                                            width: '250px',
                                            overflow: 'auto'
                                        }}>
                                            {(activity.project_activity_budget.comments.length) ?
                                                <ListGroup
                                                    flush>{this.renderComments(activity.project_activity_budget.comments)}</ListGroup> :
                                                <p>No Comments</p>
                                            }
                                        </div>

                                        <Mutation mutation={COMMENTS_MUTATION}
                                                  variables={{
                                                      data: {
                                                          project_activity_budget_id: activity.project_activity_budget.id,
                                                          user_id: this.props.user_id,
                                                          note: this.state.note,
                                                          public: this.state.public
                                                      }
                                                  }}
                                                  update={(cache, {data: {upsert_project_activity_budget_notes}}) => {
                                                      const {user} = cache.readQuery({
                                                          query: QUERY,
                                                          variables: {
                                                              user_id: this.props.user_id,
                                                              week_commencing: this.props.week_commencing
                                                          }
                                                      });

                                                      const newProjectActivities = user.project_activities.reduce((carry, pa) => {
                                                          let newPa = {...pa}

                                                          console.log(newPa, upsert_project_activity_budget_notes)

                                                          if (pa.project_activity_budget.id === upsert_project_activity_budget_notes.project_activity_budget_id) {
                                                              const newComments = [
                                                                  ...pa.project_activity_budget.comments,
                                                                  {...upsert_project_activity_budget_notes}
                                                              ]
                                                              newPa.project_activity_budget.comments = newComments
                                                          }

                                                          carry.push(newPa)
                                                          return carry
                                                      }, [])

                                                      const newUser = {
                                                          ...user,
                                                          project_activities: newProjectActivities
                                                      }

                                                      cache.writeQuery({
                                                          query: QUERY,
                                                          data: {user: newUser},
                                                          variables: {
                                                              user_id: this.props.user_id,
                                                              week_commencing: this.props.week_commencing
                                                          }
                                                      });
                                                  }}
                                        >
                                            {(go, result) => (
                                                <Row style={{position: 'fixed', bottom: '5px'}}>
                                                    <Col xs="8" style={{paddingRight: '0px'}}>
                                                        <Input style={{resize: 'none'}} type="textarea"
                                                               value={this.state.note}
                                                               onChange={(evt) => this.setState({note: evt.target.value})}/>
                                                    </Col>
                                                    <Col xs="4">
                                                        <Row>
                                                            <Col xs="12" style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                paddingBottom: '2px'
                                                            }}>
                                                                <Label check>
                                                                    <Input
                                                                        type="checkbox"
                                                                        checked={this.state.public}
                                                                        onChange={(evt) => this.setState({public: evt.target.checked})}/>{' '}
                                                                    Public
                                                                </Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs="12">
                                                                <Button
                                                                    color="primary"
                                                                    onClick={() => go().then(() => {
                                                                        this.setState({note: ''})
                                                                    })}
                                                                    disabled={result && result.loading}
                                                                >{(result && result.loading) ? '...' : 'Add'}</Button>
                                                            </Col>
                                                        </Row>

                                                    </Col>
                                                </Row>
                                            )
                                            }

                                        </Mutation>
                                    </PopoverBody>
                                </Popover>
                            </span>

                            <br/>
                            <small>{activity.project.name}</small>

                            <br/>
                            <small>
                                <strong>{(activity.project_activity_budget.stage) && `Stage: ${activity.project_activity_budget.stage} - `}{activity.project_activity_type.description}</strong> - {activity.project_activity_budget.description}
                            </small>
                            {(activity.project_activity_budget.address) &&
                            <small><br/>{activity.project_activity_budget.address.full_address}</small>}
                            {(activity.user_schedule) && <small color="secondary" style={{fontStyle: 'italic'}}>
                                <br/>{moment(activity.user_schedule.start_date).format('DD/MM/YY HH:mm')} to {moment(activity.user_schedule.end_date).format('DD/MM/YY HH:mm')}
                            </small>}
                        </Col>
                        {days.map((day, index) => (
                            <Col style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: 1,
                                display: 'flex',
                                paddingLeft: '5px',
                                paddingRight: '5px',
                            }} key={index}>
                                <Mutation
                                    mutation={MUTATION}
                                    update={(cache, {data: {upsert_user_timesheet}}) => {
                                        const {user} = cache.readQuery({
                                            query: QUERY,
                                            variables: {
                                                user_id: this.props.user_id,
                                                week_commencing: this.props.week_commencing
                                            }
                                        });

                                        const projectActivity = user.project_activities.find(({user_project_activity_id}) => user_project_activity_id === upsert_user_timesheet.user_project_activity_id)
                                        const projectActivityIndex = user.project_activities.findIndex(({user_project_activity_id}) => user_project_activity_id === upsert_user_timesheet.user_project_activity_id)

                                        const existingTimesheetIndex = projectActivity.timesheets.findIndex(({id}) => id === upsert_user_timesheet.id)

                                        let newTimesheets
                                        if (existingTimesheetIndex !== -1) {
                                            newTimesheets = [
                                                ...projectActivity.timesheets.slice(0, existingTimesheetIndex),
                                                {...upsert_user_timesheet},
                                                ...projectActivity.timesheets.slice(existingTimesheetIndex + 1)
                                            ]
                                        }
                                        else {
                                            newTimesheets = [...projectActivity.timesheets, {...upsert_user_timesheet}]
                                        }

                                        const newProjectActivities = [
                                            ...user.project_activities.slice(0, projectActivityIndex),
                                            {...projectActivity, timesheets: newTimesheets},
                                            ...user.project_activities.slice(projectActivityIndex + 1),
                                        ]

                                        const newUser = {...user, project_activities: newProjectActivities}

                                        cache.writeQuery({
                                            query: QUERY,
                                            data: {user: newUser},
                                            variables: {
                                                user_id: this.props.user_id,
                                                week_commencing: this.props.week_commencing
                                            }
                                        });
                                    }}
                                >
                                    {upsert_user_timesheet => {

                                        const isScheduled = (activity.user_schedule) ? moment().range(activity.user_schedule.start_date, activity.user_schedule.end_date).contains(moment(day)) : false
                                        const style = (!isScheduled) ? {} : {borderStyle: 'groove'}
                                        return (
                                            <Input
                                                size="sm"
                                                type="number"
                                                style={style}
                                                value={this.getExistingTimesheetValue(day, activity.timesheets)}
                                                onChange={(e) => this.timesheetChanged(e.target.value, day, activity.user_project_activity_id, upsert_user_timesheet)}
                                            />
                                        )
                                    }}
                                </Mutation>
                            </Col>
                        ))}
                    </Row>))
        )
    }

}